"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _Influencer = _interopRequireDefault(require("@deosite/ui-entities/Influencer"));
var _getRouteFromUrl = _interopRequireDefault(require("@deosite/helpers/getRouteFromUrl"));
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  link: "/"
};
var InspirationsLandingBanner = function InspirationsLandingBanner(props) {
  var label = props.label,
    title = props.title,
    subtitle = props.subtitle,
    influencer = props.influencer,
    leftImage = props.leftImage,
    backgroundColor = props.backgroundColor,
    textColor = props.textColor,
    _props$link = props.link,
    link = _props$link === void 0 ? defaultProps.link : _props$link;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var route = link && (0, _getRouteFromUrl["default"])(link);
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      width: "100%",
      flexDirection: ["column", null, null, "row"]
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 0.75,
      objectFit: "cover",
      flexBasis: "50%",
      maxHeight: "500px"
    },
    image: leftImage,
    mode: "cover",
    sizes: "(max-width: 960px) and (min-width: 10px) 100vw, 768px"
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexBasis: "50%",
      flexDirection: "column",
      bg: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "white",
      color: textColor !== null && textColor !== void 0 ? textColor : "main",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      py: ["s10", null, null, 0]
    }
  }, influencer && __jsx(_Box["default"], {
    sx: {
      mb: "s10"
    }
  }, __jsx(_Image["default"], {
    image: influencer.image,
    sx: {
      display: "inline-block",
      width: "80px",
      height: "80px",
      borderRadius: "100px",
      border: "3px",
      borderStyle: "solid",
      borderColor: "white",
      overflow: "hidden"
    },
    sizes: "210px"
  })), __jsx(_Box["default"], {
    sx: {
      font: "xxl_sans",
      width: "75%",
      display: "inline-block",
      mb: "s10",
      mt: ["s9", null, null, 0]
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      font: "body",
      width: "50%",
      display: "inline-block"
    }
  }, subtitle, " ", __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "relative",
      top: "6px"
    }
  }, __jsx(ArrowRightIcon, null))))), __jsx(Link, {
    route: route,
    params: {
      url: link
    }
  }, __jsx(_LinkRaw["default"], {
    title: label,
    sx: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      textAlign: "center"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      py: "s4",
      px: "s6",
      font: "label2",
      bg: "white",
      border: "1px",
      borderColor: "main",
      borderStyle: "solid",
      color: "main",
      position: "relative",
      top: "-10px",
      display: label ? "static" : "none"
    }
  }, label))));
};
var _default = InspirationsLandingBanner;
exports["default"] = _default;